import httpApi from "@src/utils/httpApi";
import { ITicketStatusCounts } from "@src/types/statusCheck";
import { AxiosResponse } from "axios";

export const fetchTicketStatusCounts = (): Promise<
  AxiosResponse<{ data: ITicketStatusCounts }>
> => httpApi.get("/api/tickets/status-counts");
